import { render, staticRenderFns } from "./PalletInfo.vue?vue&type=template&id=633fd1bd&scoped=true&"
import script from "./PalletInfo.vue?vue&type=script&lang=js&"
export * from "./PalletInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633fd1bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('633fd1bd')) {
      api.createRecord('633fd1bd', component.options)
    } else {
      api.reload('633fd1bd', component.options)
    }
    module.hot.accept("./PalletInfo.vue?vue&type=template&id=633fd1bd&scoped=true&", function () {
      api.rerender('633fd1bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/common/pallet/PalletInfo.vue"
export default component.exports